/* eslint-disable */

import React, {useState} from 'react'
import PageContainer  from '../../components/PageContainer/PageContainer';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { AddPressContainer, AddPressTitle, AddPressContentHeader, AddPressContentBody } from './Eaters.styled';
import { saveEater, setOpen, selectShouldOpen, selectMessage, selectSeverity } from '../Eater/slice';
import { AddEaterRequest } from './types';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import { BreadCrumbLink } from '../../components/PageContainer/PageContainer';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, {Dayjs} from 'dayjs'
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { FormControl, Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



const AddEater: React.FC = () => {
  const dispatch = useAppDispatch();
  const[ firstName, setFirstName ] = useState('');
  const[ lastName, setLastName ] = useState('');
  const[ email, setEmail ] = useState('');
  const[ dob, setDob ] = useState<Dayjs | null>(dayjs('2023-01-01'));
  const[ phone, setPhone ] = useState('');
  const[ addressLine1, setAddressLine1 ] = useState('');
  const[ addressLine2, setAddressLine2 ] = useState('');
  const[ city, setCity ] = useState('');
  const[ state, setState ] = useState('');
  const[ zipcode, setZipCode ] = useState('');
  const[ country, setCountry ] = useState('');
  const[ instagram, setInstagram ] = useState('');
  const[ facebook, setFacebook ] = useState('');
  const[ twitter, setTwitter ] = useState('');
  const[ tiktok, setTiktok ] = useState('');
  const[ persona, setPersona ] = useState('');
  const[ cuisineLikes, setCuisineLikes ] = useState('');
  const[ cuisineDislikes, setCuisineDislikes ] = useState('');
  const[ ingredientLikes, setIngredientLikes ] = useState('');
  const[ ingredientDislikes, setIngredientDislikes ] = useState('');
  const[ favoriteReviewers, setFavoriteReviewers ] = useState('');
  const[ gender, setGender ] = useState('');
  const[ incomeLevel, setIncomeLevel ] = useState('');
  const[ diningFrequency, setDiningFrequency ] = useState('');
  const[ typeOfDiningEstablishment, setTypeOfDiningEstablishment ] = useState('');
  const[ dietaryPreferences, setDietaryPreferences ] = useState('');
  const[ allergies, setAllergies ] = useState('');
  const[ socialMediaActivity, setSocialMediaActivity ] = useState('');
  const[ favoriteRestaurants, setFavoriteRestaurants ] = useState('');
  const[ foodPreparationDisliked, setFoodPreparationDisliked ] = useState('');
  const[ ambienceDisliked, setAmbienceDisliked ] = useState('');
  const[ ambienceLiked, setAmbienceLiked ] = useState('');
  const[ foodPreparationLiked, setFoodPreparationLiked] = useState('');
  const[ occupation, setOccupation ] = useState('');
  const navigate = useNavigate();

  // Accordion state - all sections expanded by default
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({
    personal: true,
    address: true,
    social: true,
    preferences: true,
    dining: true,
    other: true
  });

  const handleAccordionChange = (section: string) => (event: React.SyntheticEvent, isExpanded: boolean): void => {
    setExpandedSections(prev => ({ ...prev, [section]: isExpanded }));
  };

  const breadcrumbLinks: BreadCrumbLink[] = [
    {
      name: 'Eaters',
      url:`/eaters`
    }
  ]

  const openServer = useAppSelector(selectShouldOpen);
  const message = useAppSelector(selectMessage);
  const severity = useAppSelector(selectSeverity);

  const setOpenServer = (open: boolean) => {
    dispatch(setOpen(open));
  }

  const handleGenderChange = (event: SelectChangeEvent) => {
    setGender(event.target.value as string);
  };
    
  return (
    <PageContainer title="Add Eater" breadcrumbs={breadcrumbLinks} open={openServer} setOpen={setOpenServer} message={message} severity={severity}>
    <AddPressContainer>
      <AddPressContentHeader>
        <AddPressTitle>Add Eater</AddPressTitle>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button variant="contained" size="small" onClick={() => {
              const eater: AddEaterRequest = {
                firstName: firstName??'',
                lastName: lastName??'',
                email: email??'',
                dob: dob?.toDate(),
                phone: phone??'',
                addressLine1: addressLine1??'',
                addressLine2: addressLine2??'',
                city: city??'',
                state: state??'',
                zipcode: zipcode??'',
                country: country??'',
                instagram: instagram??'',
                facebook: facebook??'',
                twitter: twitter??'',
                tiktok: tiktok??'',
                persona: persona??'',
                cuisineLikes: cuisineLikes??'',
                cuisineDislikes: cuisineDislikes??'',
                ingredientLikes: ingredientLikes??'',
                ingredientDislikes: ingredientDislikes??'',
                favoriteReviewers: favoriteReviewers??'',
                gender: gender??'',
                incomeLevel: incomeLevel??'',
                diningFrequency: diningFrequency??'',
                typeOfDiningEstablishment: typeOfDiningEstablishment??'',
                dietaryPreferences: dietaryPreferences??'',
                allergies: allergies??'',
                socialMediaActivity: socialMediaActivity??'',
                favoriteRestaurants: favoriteRestaurants??'',
                ambienceDisliked: ambienceDisliked??'',
                foodPreparationDisliked: foodPreparationDisliked??'',
                ambienceLiked: ambienceLiked??'',
                foodPreparationLiked: foodPreparationLiked??''
              }
              dispatch(saveEater(eater));
              navigate('/eaters')
            }}>Save</Button>
            <Button variant="outlined" size="small" onClick={() => navigate('/eaters')}>
              Cancel
            </Button>
          </Box>
      </AddPressContentHeader>
      <AddPressContentBody>
        {/* Personal Information Section */}
        <Accordion expanded={expandedSections.personal} onChange={handleAccordionChange('personal')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#0a1e3d' }}>Personal Information</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, width: '100%' }}>
              <TextField id="firstName" label="First Name" variant="outlined" value={firstName} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFirstName(event.target.value);
              }}/>
              <TextField id="lastName" label="Last Name" variant="outlined" value={lastName} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setLastName(event.target.value);
              }}/>
              <TextField id="email" label="Email" variant="outlined" value={email} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(event.target.value);
              }}/>
              <TextField id="phone" label="Phone" variant="outlined" value={phone} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPhone(event.target.value);
              }}/>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date Of Birth"
                    value={dob}
                    onChange={(newValue: any) => {setDob(newValue)}}
                  />
                </LocalizationProvider>
              </Box>
              <FormControl fullWidth>
                <InputLabel id="gender-select-label">Gender</InputLabel>
                <Select
                  labelId="gender-select-label"
                  id="gender-simple-select"
                  value={gender}
                  label="Gender"
                  onChange={handleGenderChange}
                >
                  <MenuItem value={'Male'}>Male</MenuItem>
                  <MenuItem value={'Female'}>Female</MenuItem>
                  <MenuItem value={'Non-Binary'}>Non-Binary</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Address Section */}
        <Accordion expanded={expandedSections.address} onChange={handleAccordionChange('address')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#0a1e3d' }}>Address</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, width: '100%' }}>
              <TextField id="addressLine1" label="Address Line 1" variant="outlined" value={addressLine1} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAddressLine1(event.target.value);
              }}/>
              <TextField id="addressLine2" label="Address Line 2" variant="outlined" value={addressLine2} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAddressLine2(event.target.value);
              }}/>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <TextField id="city" label="City" variant="outlined" value={city} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCity(event.target.value);
                }}/>
                <TextField id="state" label="State" variant="outlined" value={state} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setState(event.target.value);
                }}/>
                <TextField id="zipCode" label="Zip Code" variant="outlined" value={zipcode} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setZipCode(event.target.value);
                }}/>
                <TextField id="country" label="Country" variant="outlined" value={country} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCountry(event.target.value);
                }}/>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Social Media Section */}
        <Accordion expanded={expandedSections.social} onChange={handleAccordionChange('social')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#0a1e3d' }}>Social Media</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, width: '100%' }}>
              <TextField id="instagram" label="Instagram" variant="outlined" value={instagram} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setInstagram(event.target.value);
              }}/>
              <TextField id="facebook" label="Facebook" variant="outlined" value={facebook} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFacebook(event.target.value);
              }}/>
              <TextField id="twitter" label="Twitter" variant="outlined" value={twitter} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setTwitter(event.target.value);
              }}/>
              <TextField id="tiktok" label="TikTok" variant="outlined" value={tiktok} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setTiktok(event.target.value);
              }}/>
              <TextField fullWidth sx={{ gridColumn: '1 / -1' }} id="socialMediaActivity" label="Social Media Activity" variant="outlined" value={socialMediaActivity} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setSocialMediaActivity(event.target.value);
              }}/>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Food & Cuisine Preferences Section */}
        <Accordion expanded={expandedSections.preferences} onChange={handleAccordionChange('preferences')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#0a1e3d' }}>Food & Cuisine Preferences</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, width: '100%' }}>
              <TextField id="cuisineLikes" label="Cuisine Likes" variant="outlined" value={cuisineLikes} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCuisineLikes(event.target.value);
              }}/>
              <TextField id="cuisineDislikes" label="Cuisine Dislikes" variant="outlined" value={cuisineDislikes} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCuisineDislikes(event.target.value);
              }}/>
              <TextField id="ingredientLikes" label="Ingredient Likes" variant="outlined" value={ingredientLikes} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setIngredientLikes(event.target.value);
              }}/>
              <TextField id="ingredientDislikes" label="Ingredient Dislikes" variant="outlined" value={ingredientDislikes} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setIngredientDislikes(event.target.value);
              }}/>
              <TextField fullWidth sx={{ gridColumn: '1 / -1' }} id="dietaryPreferences" label="Dietary Preferences" variant="outlined" value={dietaryPreferences} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setDietaryPreferences(event.target.value);
              }}/>
              <TextField fullWidth sx={{ gridColumn: '1 / -1' }} id="allergies" label="Allergies" variant="outlined" value={allergies} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAllergies(event.target.value);
              }}/>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Dining Experience Section */}
        <Accordion expanded={expandedSections.dining} onChange={handleAccordionChange('dining')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#0a1e3d' }}>Dining Experience</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, width: '100%' }}>
              <TextField id="diningFrequency" label="Dining Frequency" variant="outlined" value={diningFrequency} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setDiningFrequency(event.target.value);
              }}/>
              <TextField id="typeOfDiningEstablishment" label="Type of Dining Establishment" variant="outlined" value={typeOfDiningEstablishment} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setTypeOfDiningEstablishment(event.target.value);
              }}/>
              <TextField id="ambienceLiked" label="Ambience Liked" variant="outlined" value={ambienceLiked} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAmbienceLiked(event.target.value);
              }}/>
              <TextField id="ambienceDisliked" label="Ambience Disliked" variant="outlined" value={ambienceDisliked} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAmbienceDisliked(event.target.value);
              }}/>
              <TextField id="foodPreparationLiked" label="Food Preparation Liked" variant="outlined" value={foodPreparationLiked} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFoodPreparationLiked(event.target.value);
              }}/>
              <TextField id="foodPreparationDisliked" label="Food Preparation Disliked" variant="outlined" value={foodPreparationDisliked} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFoodPreparationDisliked(event.target.value);
              }}/>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Other Information Section */}
        <Accordion expanded={expandedSections.other} onChange={handleAccordionChange('other')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ fontSize: 18, fontWeight: 600, color: '#0a1e3d' }}>Other Information</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, width: '100%' }}>
              <TextField id="incomeLevel" label="Income Level" variant="outlined" value={incomeLevel} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setIncomeLevel(event.target.value);
              }}/>
              <TextField id="occupation" label="Occupation" variant="outlined" value={occupation} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setOccupation(event.target.value);
              }}/>
              <TextField id="favoriteReviewers" label="Favorite Reviewers" variant="outlined" value={favoriteReviewers} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFavoriteReviewers(event.target.value);
              }}/>
              <TextField id="favoriteRestaurants" label="Favorite Restaurants" variant="outlined" value={favoriteRestaurants} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFavoriteRestaurants(event.target.value);
              }}/>
              <TextField fullWidth sx={{ gridColumn: '1 / -1' }} id="persona" label="Persona" multiline rows={4} variant="outlined" value={persona} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPersona(event.target.value);
              }}/>
            </Box>
          </AccordionDetails>
        </Accordion>
      </AddPressContentBody>
      </AddPressContainer>
    </PageContainer>
  )
}

export default withAuthenticationRequired(AddEater)
